import React from "react";
import styled from "styled-components";
import { device } from "../utils/utils";
import { motion } from "framer-motion";

const Wrapper = styled.div`
  cursor: none;
  overflow: hidden;
`;

const Mouse = styled.div`
  position: absolute !important;
  /* left: -50px !important;
  top: -50px !important; */
  pointer-events: none;
  z-index: 99;
  /* transform: ${({ pos }) => `translate(${pos.x + 50}px,${pos.y + 50}px)`}; */
  @media ${device.tablet} {
    display: none;
  }
  svg {
    position: relative;
    width: 20px;
    height: 20px;
  }
`;

const Cursor = ({ Icon, children, disabled }) => {
  const [pos, setPos] = React.useState({ x: 0, y: 0 });
  const [on, setOn] = React.useState(false);

  const handleMouseEnter = () => {
    setOn(true);
  };

  const handleMouseLeave = () => {
    setOn(false);
  };

  const handleMouseMove = (e) => {
    if (on) {
      let x = e.nativeEvent.offsetX;
      let y = e.nativeEvent.offsetY;
      //   console.log(e);
      setPos({ x: x, y: y });
    }
  };

  if (disabled) {
    return <>{children}</>;
  }

  return (
    <Wrapper
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseMove={handleMouseMove}
    >
      {on && (
        <Mouse
          as={motion.div}
          pos={pos}
          animate={{ x: pos.x, y: pos.y }}
          transition={{ duration: 0 }}
        >
          <Icon />
        </Mouse>
      )}
      <div>{children}</div>
    </Wrapper>
  );
};

export default Cursor;
